import { Capacitor } from '@capacitor/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function checkCapacitorAndPluginsAvailable<T extends (...args: any[]) => any>(
  plugins: string[],
  f: T,
): T | (() => undefined) {
  return (...args: Parameters<T>): ReturnType<T> | undefined => {
    if (!('Capacitor' in window)) throw new Error('Capacitor is not available');

    for (let i = 0; i < plugins.length; i += 1) {
      if (!Capacitor.isPluginAvailable(plugins[i])) {
        if (plugins[i] !== 'sqlitePlugin') {
          throw new Error(`${plugins[i]} is not available`);
        } else {
          // If the plugin is sqlitePlugin, we want to return instead of throwing. This is something we don't need to handle as an error as it's used in the initialization of the app
          return;
        }
      }
    }

    // eslint-disable-next-line consistent-return
    return f(...args);
  };
}

export default checkCapacitorAndPluginsAvailable;
